import { TextCaption } from '@carboncopyco/ui';
import { useEffect, useRef } from 'react';
import { InputField } from '../InputField';
import { InputTextArea } from '../InputTextArea';

type PromptProps = {
  value: string;
  onChange: (value: string) => void;
  textError?: string;
  disabled?: boolean;
  inputLabel?: string;
};

export const Prompt = ({
  value,
  onChange,
  textError,
  disabled,
  inputLabel = 'What changes should be made to this column?',
}: PromptProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);

  return (
    <div className="flex flex-col pb-4">
      <InputField
        label={inputLabel}
        name="prompt"
        error={
          textError ? (
            <TextCaption
              color="text-ds-danger"
              label={textError}
            />
          ) : undefined
        }
      >
        <InputTextArea
          ref={ref}
          disabled={disabled}
          autoFocus
          state="normal"
          rows={4}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="What changes should be made to this column?"
        />
      </InputField>
    </div>
  );
};
